"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./lib/ActorRdfMetadata"));
__export(require("./lib/ActorRdfMetadataQuadPredicate"));
//# sourceMappingURL=index.js.map